import React from 'react';
import { BatteryLow, Waves, Cloud } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const symptoms = [{
    icon: BatteryLow,
    title: 'Fatiga Crónica',
    desc: 'Despertar agotada a pesar de dormir 8 horas. Depender del café solo para sobrevivir el bajón de la tarde.'
  }, {
    icon: Waves,
    title: 'Hinchazón Inexplicable',
    desc: "Sentirte incómoda en tu propia ropa para las 3 PM, sin importar qué tan 'limpio' hayas comido."
  }, {
    icon: Cloud,
    title: 'Niebla Mental',
    desc: 'Costarte concentrarte, olvidar palabras simples y sentirte desconectada de tu versión más lúcida.'
  }];
  return <section className="py-14 md:py-20 bg-cream" data-id="element-139">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-140">
        <div className="text-center mb-10 md:mb-14" data-id="element-141">
          <FadeIn data-id="element-142">
            <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-4 block" data-id="element-143">
              La Realidad
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-ink" data-id="element-144">
              ¿Te suena <em className="italic" data-id="element-145">familiar?</em>
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-146">
          {symptoms.map((symptom, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-147">
              <div className="group bg-white p-6 md:p-7 h-full border border-ink/5 shadow-soft hover:shadow-soft-lg transition-all duration-500 hover:-translate-y-1" data-id="element-148">
                <div className="w-10 h-10 bg-sage rounded-full flex items-center justify-center mb-5 text-ink group-hover:scale-110 transition-transform duration-500" data-id="element-149">
                  <symptom.icon strokeWidth={1.5} className="w-5 h-5" data-id="element-150" />
                </div>
                <h3 className="font-serif text-xl md:text-2xl mb-3 text-ink" data-id="element-151">
                  {symptom.title}
                </h3>
                <p className="text-sm md:text-base text-ink-light font-light leading-relaxed" data-id="element-152">
                  {symptom.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}